import { templateThemeTokens } from './templateThemeTokens.js';
import { THEME_DEFAULT_FONTS } from '@/contexts/CustomThemeConfigContext/constants.js';
import { createTheme } from '@/stitches/index.js';
import { merge } from 'lodash-es';

const themeObject = merge(templateThemeTokens, {
  colors: {
    defaultFont: '#000000',
    pageBackground: '#D7DBCF',
    secondaryFont: '#DCFF7A',
    sectionBackground: '#FBFBF8',
  },
  fonts: {
    accent: THEME_DEFAULT_FONTS.barcelona.morning.accent
      ? THEME_DEFAULT_FONTS.barcelona.morning.accent.value
      : 'unset',
    body: THEME_DEFAULT_FONTS.barcelona.morning.body.value,
    heading: THEME_DEFAULT_FONTS.barcelona.morning.headline.value,
  },
  fontWeights: {
    heading: '600',
  },
});

export const morning = createTheme({ ...themeObject });
